import { baseApiPath } from './common';

export const resultDashboardBase = `${baseApiPath}/result/dashboard`;
export const resultDashboardClientsBase = `${baseApiPath}/admin/clients`;
export const resultBase = `${baseApiPath}/admin/dashboard`;
export const personaBase = `${baseApiPath}/result/persona`;
export const resultClientBase = `${baseApiPath}/result/client`;

export const ENDPOINTS = {
	resultDashboardBase,
	resultDashboardComments: `${resultDashboardBase}/comments`,
	resultDashboardWordcloud: `${resultDashboardBase}/comments/wordscloud`,
	resultDashboardRounds: `${resultDashboardBase}/rounds`,
	resultDashboardServices: `${resultDashboardBase}/services`,
	resultDashboardRoles: `${resultDashboardBase}/roles`,
	resultDashboardBusinessUnits: `${resultDashboardBase}/business-units`,
	resultDashboardTrends: `${resultDashboardBase}/trends`,
	resultDashboardPoints: `${resultDashboardBase}/points`,
	locationSearch: `${resultDashboardBase}/points/search`,
	resultDashboardServicesCards: `${resultDashboardBase}/services/trends`,
	resultDashboardServiceStats: `${resultDashboardBase}/services/{{serviceId}}/histogram`,
	resultDashboardRangeData: `${resultDashboardBase}/range-data`,
	resultDashboardNPSTrends: `${resultDashboardBase}/nps/trends`,
	resultDashboardQuestionAnswers: `${resultDashboardBase}/answers`,
	resultDashboardQuestionAnswersWordcloud: `${resultDashboardBase}/answers/wordscloud`,
	dashboardReport: `${resultDashboardBase}/download/report`,
	locationStatistic: `${resultDashboardBase}/grid/statistic`,
	regions: `${resultDashboardBase}/regions`,
	reportMetrics: `${resultDashboardBase}/report`,
	clientLogo: `${resultClientBase}`,
	shortClients: `${resultDashboardClientsBase}/all/short`,
	resultSurveyRoundList: `${resultBase}/surveys/rounds`,
	resultEmployeeList: `${resultBase}/surveys/employees`,
	personaData: `${personaBase}/all`,
	personaTrends: `${personaBase}/services/trends`,
	personaRoles: `${personaBase}/typical-roles`,
	personaWorkStyle: `${personaBase}/workstyle`,
	personaSatisfaction: `${personaBase}/service/overall-satisfaction`,
	personaComments: `${personaBase}/comments`,
	personaCommentsWordcloud: `${personaBase}/comments/wordscloud`,
	personaRespondents: `${personaBase}/respondents/count`,
};
